/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { IComparator } from '../interface/icomparator';

export class NameValue implements IComparator {
  public name: string;
  public value: any;
  public displayId: boolean;
  public displayLabel: boolean;

  constructor(name: string, value: any, displayId = true, displayLabel = true) {
    this.name = name;
    this.value = value;
    this.displayId = displayId;
    this.displayLabel = displayLabel;
  }

  public toString(): string {
    if (this.name && this.displayId) {
      if (this.value && this.displayLabel) {
        return `${this.name} - ${this.value}`;
      } else {
        return `${this.name}`;
      }
    } else if (this.displayLabel) {
      return this.value;
    } else {
      return null;
    }
  }

  compare(comparant: NameValue | string | any): number {
    if (comparant instanceof NameValue) {
      return this.value.toString().localeCompare(comparant.value.toString());
    }
    if (typeof comparant === 'string') {
      return this.value.localeCompare(comparant);
    }
    if (Object.hasOwn(comparant, 'id')) {
      return this.value.name.toString().localeCompare(comparant.id);
    }
    if (comparant.getId) {
      return this.value.name.toString().localeCompare(comparant.getId());
    }
    return undefined;
  }

  serialize() {
    return {
      name: this.name,
      value: this.value,
    };
  }
}
